<template>
    <div class="ah-card shadow deposit-list-card" style="height: 100%; min-height: 100px;">
        <div class="title">
            <span>
                <div style="margin-top: 5px">
                    <span>{{ title }}</span>
                    <span style="font-size: 9pt; font-weight: normal; margin-left: 12px; color: #aaa;">{{ date }}</span>
                </div>
                <div class="total-value" v-if="!isLoading">
                    <span v-if="totalPrefix !== ''" class="totalprefix">{{ totalPrefix }}</span>
                    <span class="value"><money :v="total" round/></span>
                    <span class="cny">TWD</span>
                </div>
            </span>
            <div>
                <ahTextSwitch trueText="全部" falseText="有餘額" v-model="isShowAll" />
            </div>
        </div>
        <div class="content">
            <div v-loading="isLoading" element-loading-background="rgba(255, 255, 255, 0.5)" element-loading-text="載入中" style="min-height: 100px">
                <table class="ah-default-simple-table hover" cellspacing="0" cellpadding="0">
                    <thead>
                        <tr>
                            <th class="cell-nam">帳戶名稱</th>
                            <th class="cell-amt">餘額</th>
                            <th class="cell-cny">幣別</th>
                            <th v-if="showRat" class="cell-rat">匯率</th>
                            <th v-if="showEqualTwd" class="cell-amt">約當台幣</th>
                            <th v-if="showPercentage" class="cell-per">佔比</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in filterdList" :key="item.sno">
                            <td class="cell-nam">{{ item.bnK_NAM }}</td>
                            <td class="cell-amt"><money :v="item.bal" /></td>
                            <td class="cell-cny">{{ item.cny }}</td>
                            <td v-if="showRat" class="cell-rat">{{ item.rat }}</td>
                            <td v-if="showEqualTwd" class="cell-amt">
                                <money :v="Math.round(item.bal * item.rat)" />
                            </td>
                            <td v-if="showPercentage" class="cell-per">{{ getPercent(item.bal, item.rat, total) }}%</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!isLoading && list.length === 0" class="empty-display">
                    (無資料)
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import ahTextSwitch from '@/components/ui/ahTextSwitch.vue';

export default {
    components: {
        ahTextSwitch,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '標題',
        },
        list: {
            type: Array,
            default: () => [],
        },
        showRat: {
            type: Boolean,
            default: true,
        },
        showEqualTwd: {
            type: Boolean,
            default: true,
        },
        showPercentage: {
            type: Boolean,
            default: true,
        },
        abs: {
            type: Boolean,
            default: false,
        },
        totalPrefix: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '---'
        }
    },
    data() {
        return {
            isShowAll: false,
        };
    },
    computed: {
        filterdList() {
            return this.isShowAll ? this.list : this.list.filter((x) => x.bal !== 0);
        },
        total() {
            if (this.filterdList.length === 0) return 0;
            return this.filterdList.map((x) => x.bal * x.rat).reduce((a, b) => a + b);
        },
    },
    methods: {
        getPercent(value, rat, total) {
            return Math.round((Math.round(value * rat) / Math.round(total)) * 1000) / 10;
        },
    },
};
</script>
<style lang="scss">
.deposit-list-card {
    > .title {
        @media (max-width: 720px) {
            padding: 12px 25px;
        }
    }

    .empty-display {
        text-align: center;
        color: #888;
        font-size: 10pt;
        line-height: 50px;
    }

    .total-value {
        margin: 5px 0px;
        color: #000;

        .totalprefix {
            font-size: 9pt;
            margin-right: 10px;
            font-weight: normal;
        }

        .value {
            font-size: 15pt;
        }
        .cny {
            font-size: 9pt;
            margin-left: 10px;
            font-weight: normal;
        }
    }
}
</style>
